import { render, staticRenderFns } from "./DiscountProgressBar.vue?vue&type=template&id=e809acf2&"
import script from "./DiscountProgressBar.vue?vue&type=script&lang=ts&"
export * from "./DiscountProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountProgressBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports